module.exports = __webpack_public_path__ + "images/usermodule/03.gif";


//////////////////
// WEBPACK FOOTER
// ./images/usermodule/03.gif
// module id = 1572
// module chunks = 4